// themeColors.js
export const themeColors = {
	blue: {
		light: "#3AABE4",
		main: "#1D99D6",
		dark: "#146690",
		contrastText: "#fff",
	},
	red: {
		light: "#FFCDD2",
		main: "#F44336",
		dark: "#D32F2F",
		contrastText: "#fff",
	},
	orange: {
		light: "#FFE0B2",
		main: "#FF9800",
		dark: "#F57C00",
		contrastText: "#fff",
	},
	cyan: {
		light: "#B2EBF2",
		main: "#00BCD4",
		dark: "#0097A7",
		contrastText: "#fff",
	},
};